// extracted by mini-css-extract-plugin
module.exports = {"OrderCancelModal":"OrderCancelModal_OrderCancelModal__16OCi","ModalContent":"OrderCancelModal_ModalContent__2OG_u","Items":"OrderCancelModal_Items__166m_"};